import { SUBSCRIPTION } from './index';
import { Action } from '../action';
import { SubscriptionInfo } from '@shared/core';

export class SubscriptionInitAction implements Action {
	readonly type = SUBSCRIPTION.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class SubscriptionDestroyAction implements Action {
	readonly type = SUBSCRIPTION.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class SubscriptionHydrateAction implements Action {
	readonly type = SUBSCRIPTION.HYDRATE;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class SubscriptionHydrateSuccessAction implements Action {
	readonly type = SUBSCRIPTION.HYDRATE_SUCCESS;
	constructor(
		public payload: SubscriptionInfo,
		public correlationId?: number
	) {}
}

export class SubscriptionHydrateFailureAction implements Action {
	readonly type = SUBSCRIPTION.HYDRATE_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}
